import { createFileRoute } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

import { AppCatalogPage } from '@/pages/organization-settings/apps/AppsManagementPage';

export const Route = createFileRoute('/$slug/organization-settings/apps')({
  beforeLoad: createCaslGuard('OrgSettings'),
  component: AppCatalogPage
});
